exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sticky-header[data-v-54d0ae41] {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 55px;\n    z-index: 2; /* Opcjonalne: Jeśli masz inne elementy z wyższym z-index, aby nagłówki były na wierzchu */\n}\n.small-font[data-v-54d0ae41] {\n    font-size: smaller;\n}\n", ""]);

// exports
